// maps over crew array to give total of additional & reg expenses,
// gives back other totals too
export default function calculateTotals(
  crewArray,
  paidAmt = 0,
  discountAmt = 0
) {
  // debugger;
  let originalTotal, additionalTotal, payAble
  let newArray = []
  let newArray2 = []
  let newArray3 = []
  crewArray.map(x => {
    x.additional_expenses &&
      x.additional_expenses.map(y => {
        newArray2 = [
          ...newArray2,
          y.is_percentage
            ? y.quantity * y.actual_rate +
            y.quantity * y.actual_rate * (y.client_rate / 100) -
            y.discount
            : y.quantity * y.actual_rate +
            (y.quantity > 0 ? y.client_rate : 0) -
            y.discount,
        ]
        return newArray2
      })
    x.expenses &&
      x.expenses.map(y => {
        if (y.class !== "non-billable") {
          newArray3 = [
            ...newArray3,
            y.is_percentage
              ? y.quantity * y.actual_rate +
              y.quantity * y.actual_rate * (y.client_rate / 100) -
              y.discount
              : y.quantity * y.actual_rate +
              (y.quantity > 0 ? y.client_rate : 0) -
              y.discount,
          ]
        }
        newArray = [
          ...newArray,
          y.is_percentage
            ? y.quantity * y.actual_rate +
            y.quantity * y.actual_rate * (y.client_rate / 100) -
            y.discount
            : y.quantity * y.actual_rate +
            (y.quantity > 0 ? y.client_rate : 0) -
            y.discount,
        ]
        return { newArray, newArray3 }
      })
    return { newArray, newArray2, newArray3 }
  })
  originalTotal = newArray.reduce((partial_sum, a) => partial_sum + a, 0)
  additionalTotal = newArray2.reduce((partial_sum, a) => partial_sum + a, 0)
  payAble = newArray3.reduce((partial_sum, a) => partial_sum + a, 0)

  return {
    additional: additionalTotal,
    original: originalTotal,
    half: (payAble - discountAmt) / 2,
    remaining: additionalTotal + Number(payAble.toFixed(2)) - paidAmt - discountAmt,
    paid: paidAmt,
    payAble
  }
}
